import * as React from 'react';

import { Block, Row } from 'emotion-jsxstyle';

import { Link } from 'react-router-dom';
import { MediaImage } from '../../MediaImage';
import { Member } from 'common/api/models/Member';

import Media from 'react-media';

interface NavbarProps {
  currentUser: Member;
  toggleNav: () => void;
  isOpen: boolean;
}

interface NavbarState {}

// tslint:disable:max-line-length
export class Navbar extends React.Component<NavbarProps, NavbarState> {
  public render() {
    return (
      <Row
        background="#091524"
        position="fixed"
        top="0"
        right="0"
        width="100%"
        height={56}
        alignItems="stretch"
        zIndex="200"
      >
        <Row alignItems="center" justifyContent="center">
          <Block position="relative" className="navbar-dark" marginLeft=".5rem">
            <button
              className="navbar-toggler navbar-inverse"
              type="button"
              aria-controls="navbarNav"
              aria-expanded={this.props.isOpen}
              aria-label="Toggle navigation"
              onClick={this.props.toggleNav}
            >
              <span className="navbar-toggler-icon" />
            </button>
          </Block>
        </Row>
        <Row width={240} alignItems="center" padding="1rem 1.75rem">
          <Link to="/">
            <svg width="73px" height="25px" className="d-block" viewBox="0 0 228 79" version="1.1" aria-hidden="true">
              <polyline
                id="Fill-1"
                fill="#B4B5B4"
                points="60.9503236 1.11974507 48.2882956 1.11974507 48.2882956 44.407045 2.2878063 1.11974507 0 1.11974507 0 78.3928532 14.7975501 78.3928532 14.7715791 35.14478 60.9503236 78.3928532 60.9503236 1.11974507"
              />
              <path
                d="M142.564095,64.3865303 L128.021533,64.3865303 L128.021533,43.1589215 L141.662194,43.1589215 C148.878582,43.1589215 153.049284,47.472674 153.049284,53.7156688 C153.049284,60.0727778 148.990729,64.3865303 142.564095,64.3865303 L142.564095,64.3865303 Z M128.021533,15.1201245 L140.985768,15.1201245 C145.834076,15.1201245 148.651926,17.9575253 148.651926,22.3853919 C148.651926,26.8120699 145.269798,29.6494706 140.197195,29.6494706 L128.021533,29.6494706 L128.021533,15.1201245 L128.021533,15.1201245 Z M94.5862705,36.1206937 L112.238266,12.1079865 L112.238266,61.9497177 L94.5862705,36.1206937 L94.5862705,36.1206937 Z M153.386906,35.3254607 C160.039016,33.1691788 164.209717,28.2884217 164.209717,21.1360797 C164.209717,10.2381787 156.205937,1.11974507 141.887669,1.11974507 L102.364576,1.11974507 L76.5482517,36.5224706 L76.5482517,1.11974507 L60.7649854,1.11974507 L60.7649854,78.3928532 L76.5482517,78.3928532 L76.5482517,57.0071487 L83.9889345,48.0396787 L104.393853,78.3928532 L143.240521,78.3928532 C159.250443,78.3928532 168.944697,68.2462036 168.944697,54.5097131 C168.944697,44.8611242 163.872095,37.8228964 153.386906,35.3254607 L153.386906,35.3254607 Z"
                id="Fill-33"
                fill="#fff"
              />
              <path
                d="M180.963354,56.2844258 L190.860654,32.1659253 L201.05544,56.2844258 L180.963354,56.2844258 L180.963354,56.2844258 Z M191.826302,0.133133172 L190.466367,0.133133172 L156.576613,78.3928532 L171.878236,78.3928532 L175.504728,69.6369697 L206.699404,69.6369697 L210.324715,78.3928532 L227.07481,78.3928532 L191.826302,0.133133172 L191.826302,0.133133172 Z"
                id="Fill-34"
                fill="#B4B5B4"
              />
            </svg>
          </Link>
        </Row>

        <Row flex="1" alignItems="center">
          <Row flex="1" alignItems="center" justifyContent="center" className="px-3 px-sm-4">
            {/* <Block
              component="label"
              width="100%"
              flex="1"
              marginBottom="0"
              position="relative"
              props={{ htmlFor: 'global-search' }}
            >
              <Block
                component="i"
                color="#999"
                opacity=".65"
                className="fa fa-search"
                position="absolute"
                top=".65rem"
                left=".5rem"
              />
              <Block
                component="input"
                border="0"
                color="#fff"
                focusColor="#555"
                height="40"
                borderRadius="2px"
                width="100%"
                padding=".5rem"
                paddingLeft="2rem"
                fontSize="1rem"
                lineHeight="1.25"
                props={{ placeholder: 'Global search coming soon...', disabled: true }}
                focusBackgroundColor="#fff"
                focusOutline="0"
                focusOpactiy="1.0"
                backgroundColor={'rgba(255,255,255,.15)'}
              />
            </Block> */}
          </Row>
          <Media
            query="(min-width: 768px)"
            render={() => (
              <Row
                alignItems="center"
                paddingLeft="1rem"
                paddingRight="2rem"
                component={Link}
                props={{ to: '/settings' }}
                color="#aaa"
                css={{
                  ':hover': {
                    backgroundColor: '#111',
                    color: '#eee',
                  },
                }}
              >
                <Block marginRight=".5rem">
                  <MediaImage
                    path={this.props.currentUser.imagePath}
                    size="sm"
                    height={32}
                    width={32}
                    className="rounded-circle"
                  />
                </Block>
                <Block>{this.props.currentUser.email!}</Block>
              </Row>
            )}
          />
        </Row>
      </Row>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/layout/Navigator/Navbar.tsx